// @flow
import * as React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import type { Booking } from '../../types';

type Props = {
  currentBooking: Booking,
  bookings: Booking[],
  params: {
    bookingId: string,
    organisationId: string,
    context: string
  },
  router: {
    push: (s: string) => void
  },
  getBooking: Function,
  updateBooking: Function,
  addBooking: Function
};

type State = {
  loading: boolean,
  isSaving: boolean,
  isArchiving: boolean,
  successMsg?: string,
  errorMsg?: string
};

class BookingDetails extends React.Component<Props, State> {
  timeoutId: ?any;

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      isSaving: false,
      isArchiving: false,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    Promise.all([this.loadBookingData(this.props)]).then(success => {
      this.setState({ loading: false });
    });
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  componentWillReceiveProps(nextProps: Props) {
    // if currentBooking has changed
    const currentBookingId =
      this.props.currentBooking && this.props.currentBooking.id;
    const newBookingId =
      nextProps.currentBooking && nextProps.currentBooking.id;
    if (newBookingId !== currentBookingId) {
      this.loadBookingData(nextProps);
    }
  }

  loadBookingData = (props: Props) => {
    const {
      params: { bookingId, organisationId }
    } = props;
    const promisesToRun = [];

    if (bookingId === 'new') {
      promisesToRun.push(this.props.getBooking(parseInt(organisationId, 10)));
    }

    return Promise.all(promisesToRun);
  };

  currentOrgId = () => parseInt(this.props.params.organisationId, 10);

  success = (redirect: any, response: Object, isNew: boolean = false) => {
    if (!redirect) {
      // not going to Map page
      this.setState({
        isSaving: false,
        errorMsg: undefined,
        successMsg: 'Success!'
      });
      this.timeoutId = setTimeout(
        () => this.setState({ successMsg: undefined }),
        3000
      );

      if (isNew) {
        // new booking has been created by clicking 'Save'.
        // need to redirect to new booking page
        const currentOrgId = this.currentOrgId();
        const context = this.props.params.context;
        const newBookingId = response.data.id;
        this.props.router.push(
          `/${context}/${currentOrgId}/bookings/${newBookingId}`
        );
      }
    }
  };

  failure = (error: Object) => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  handleSubmit = (values: any) => {
    let redirect = false;
    this.addOrUpdateBooking(values, redirect);
  };

  addOrUpdateBooking = (values: Object, redirect: boolean = false) => {
    this.setState({ isSaving: true });
    const currentOrgId = this.currentOrgId();
    const context = this.props.params.context;

    if (values.id) {
      this.props
        .updateBooking(values, context, redirect)
        .then(
          success => this.success(redirect, success),
          error => this.failure(error)
        );
    } else {
      this.props
        .addBooking(values, currentOrgId, context, redirect)
        .then(
          success => this.success(redirect, success, true),
          error => this.failure(error)
        );
    }
  };

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    }
    var campaignName =
      this.props.bookings.filter(
        booking => booking.id === this.props.currentBooking.id
      ).length > 0
        ? this.props.bookings.filter(
            booking => booking.id === this.props.currentBooking.id
          )[0].campaignName
        : 'View Campaign';
    return (
      <div>
        <h1> Booking Details</h1>
        {this.props.currentBooking && this.props.currentBooking.bookingNumber && (
          <Row>
            <Col xs={6} lg={6}>
              <span className="form--label">Booking Number</span>
              <p>{this.props.currentBooking.bookingNumber}</p>
            </Col>
            <Col xs={6} lg={6}>
              <span className="form--label">Date of Creation</span>
              <p>
                {moment(this.props.currentBooking.dateCreated).format(
                  'DD/MM/YYYY'
                )}
              </p>
            </Col>
            <Col xs={6} lg={6}>
              <span className="form--label">Campaign</span>
              <p>
                <a
                  href={
                    '/customer/' +
                    (this.props.currentBooking.organisationId || '') +
                    '/campaigns/' +
                    (this.props.currentBooking.campaignId || '')
                  }
                >
                  {campaignName}
                </a>
              </p>
            </Col>
            <Col xs={6} lg={6}>
              <span className="form--label">Addresses Downloaded</span>
              <p>{this.props.currentBooking.totalNumberOfRecordsSaved}</p>
            </Col>
          </Row>
        )}
        {!this.props.currentBooking ||
          (!this.props.currentBooking.bookingNumber && (
            <p>No Booking Selected</p>
          ))}
      </div>
    );
  }
}

export default BookingDetails;



// WEBPACK FOOTER //
// ./src/containers/bookings/BookingDetails.js